const useViewModel = <P>(props: P): P => props;

export { useViewModel };
